import * as z from "zod/v4";

export const proxyLinearImage = {
  name: "proxyLinearImage" as const,
  input: z.object({ imageUrl: z.string() }),
  output: z.object({
    // Base64 encoded image data with data URL prefix
    dataUrl: z.string().nullable(),
    error: z.string().nullable(),
  }),
};
